import { Global, css } from "@emotion/react";

const styles = css`
  html,
  body,
  #__next,
  .livepix--widget--animation-container {
    height: 100%;
    padding: 0;
    margin: 0;
    background: transparent !important;
  }
`;

const GlobalStyle = () => <Global styles={styles} />;

export default GlobalStyle;
